import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

const ns = `bundle-savings`;

const BundleList = ({ price, compareAtPrice }) => {
	const rootClassnames = classNames({ [`${ ns }`]: true });
	const [bundleSavings, setBundleSavings] = useState(null);

	useEffect(() => {
		setBundleSavings((((compareAtPrice - price) / compareAtPrice) * 100).toFixed(0));
	}, []); // eslint-disable-line

	return (
		<div className={rootClassnames}>
			<div className={`${ ns }__bundle-savings`}>
				You save
				{' '}
				{bundleSavings}
				% by buying these items together.
			</div>
		</div>
	);
};

export default BundleList;
